export default function Homepage() {
  return (
    <iframe
      src="/42exteriors.html"
      style={{ width: "100%", height: "100vh", border: "none", display: "block" }}
      title="42 Exteriors"
    />
  );
}
